module.exports = __webpack_public_path__ + "static/img/oilApplication4.180fd5dc.png";